import { Link } from 'react-router-dom';
import { relativeDay } from '@/lib/dashboardFormat';
import type { ActivityItem } from '@/api/dashboard';

/**
 * Провалившиеся события подсвечиваем — их и надо замечать в ленте.
 * Значения статуса в histories русские: «Успешно» / «Ошибка».
 */
function isFailure(status: string | null): boolean {
  return status === 'Ошибка';
}

export function ActivityFeed({ items }: { items: ActivityItem[] }) {
  if (items.length === 0) {
    return <p className="activity-feed__empty">Событий пока нет.</p>;
  }

  return (
    <ul className="activity-feed">
      {items.map((item) => (
        <li className="activity-feed__row" key={item.id}>
          <span
            className={`activity-feed__dot${isFailure(item.status) ? ' activity-feed__dot--fail' : ''}`}
            aria-hidden="true"
          />
          <div className="activity-feed__body">
            <Link className="activity-feed__company" to={`/clients/${item.clientId}`}>
              {item.company ?? 'Без названия'}
            </Link>
            <div className="activity-feed__desc">{item.description ?? 'Без описания'}</div>
          </div>
          <span className="activity-feed__when">{relativeDay(item.at)}</span>
        </li>
      ))}
    </ul>
  );
}
